import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';

// const SpecTable = () => {

    // const tables = document.querySelectorAll('.spec-table');

    // const specTableConstructor = (id) => {
        const specsTableTemplate = () => {
            Vue.component('spec-table-template', {
                props: ['selectedItem'],
                data: function() {
                    return {
                        selectedUnit: store.state.units,
                        usLabel: '',
                        metricLabel: '',
                        labelText: '',
                        store: store,
                        switchToText: '',
                        loadMore: true,
                        isOpen: null
                    }
                },
                computed: {
                    computedUnit: function() {
                        return store.state.units;
                    },
                    taggingMeta: function() {
                        return JSON.stringify({
                            "type": "cta",
                            "category": "View all",
                            "action": "Specifications",
                            "label": this.selectedItem ? this.selectedItem : ""
                        })
                    }
                },
                watch: {
                    computedUnit: function() {
                        this.selectedUnit = this.computedUnit;
                        this.setLabels();
                    }
                },
                methods: {
                    toggleUnits() {
                        store.commit('setUnits');
                    },
        
                    setLabels() {
                        this.labelText = this.selectedUnit == 'us' ? this.usLabel : this.metricLabel;
                        this.switchToText = this.selectedUnit == 'us' ? this.metricLabel : this.usLabel;
                    },
        
                    handleViewAll() {
                        this.$refs.loadMore.viewAll();
                    },
                },
                mounted() {
                    // get labels from mark up to accomodate multi lang
                    this.usLabel = this.$refs.unitToggler.dataset.usLabel;
                    this.metricLabel = this.$refs.unitToggler.dataset.metricLabel;
                    this.setLabels();
                    EventBus.$on('toggleOpen', (state) => {
                        this.isOpen = state;
                    });

                }
            });
        }

        const specTableLoadMore = () => {
            Vue.component('specifications-load-more', {
                props: ['labelText', 'switchToText', 'selectedUnit', 'isOpen'],
                data: function() {
                    return {
                        innerHeight: null,
                        // isOpen: false
                    }
                },
                methods: {
                    viewAll() {
                        let contentArea = this.$refs.allContainer;
                        let contentHeight = this.innerHeight;
        
                        if (this.isOpen == true) {
                            // this.isOpen = false;
                            EventBus.$emit('toggleOpen', false);
        
                            requestAnimationFrame(function() {
                                //set content area height to content height to prevent transitioning from auto
                                contentArea.style.maxHeight = contentHeight + 'px';
                                // have the element transition to height: 0
                                requestAnimationFrame(function() {
                                    contentArea.style.maxHeight = '0px';
                                });
                            });
        
                            contentArea.addEventListener('transitionend', () => {
                                contentArea.style.maxHeight = '0';
                            });
        
                        } else {
                            // this.isOpen = true;
                            EventBus.$emit('toggleOpen', true);
                            contentArea.style.maxHeight = contentHeight + "px";
                            contentArea.addEventListener('transitionend', () => {
                                contentArea.style.maxHeight = 'none';
                            });
                        }
                    }
                },
                mounted() {
                    this.innerHeight = this.$refs.allInner.getBoundingClientRect().height;
                }
            });
        }
    

        // new Vue({
        //     el: `.spec-table-${id}`,
        //     store: store,
        // }).$mount(`.spec-table-${id}`, true);
    // }
    
    // if (tables.length > 0) {
    //     tables.forEach((item, index) => {
    //         item.classList.add(`spec-table-${index}`);
    //         specTableConstructor(index);
    //     })
    // }

// }

// export default SpecTable;

export {specsTableTemplate, specTableLoadMore}; 